import React, { Component } from 'react'
import { connect } from 'react-redux'
import { pageActions } from '../_actions'
import { ImageCarousel, Block } from './'
import ReactGA from 'react-ga'


class About extends Component {
    componentWillReceiveProps(nextProps) {
        const currentPage = this.props.location.pathname;
        const nextPage = nextProps.location.pathname;

        if (currentPage !== nextPage && process.env.NODE_ENV !== 'development') {
            ReactGA.pageview(window.location.pathname)
        }
    }

    componentDidMount() {
        const { about, dispatch } = this.props

        window.scrollTo(0, 0)

        if (!about) {
            dispatch(pageActions.getPage('about'))
        }
    }

    render() {
        const { about } = this.props
        const page = about || {}
        const content = page.content || []

        return (
            <div className="content" id="about">
                {
                    page.intro ? (
                        <div className="intro">
                            <p dangerouslySetInnerHTML={{ __html: page.intro }}></p>
                        </div>
                    ) : ''
                }
                <div className="blocks">
                    <div className="block left-block">
                        {
                            content.length ? (
                                content.filter(e => e.position === 'left').sort((a, b) => a.order > b.order ? 1 : -1 ).map((e, i) => (
                                    <Block key={ i } content={ e } />
                                ))
                            ) : ''
                        }
                    </div>
                    <div className="block right-block">
                        {
                            content.length ? (
                                content.filter(e => e.position === 'right').sort((a, b) => a.order > b.order ? 1 : -1 ).map((e, i) => (
                                    <Block key={ i } content={ e } />
                                ))
                            ) : ''
                        }
                    </div>
                </div>
                <ImageCarousel images={ page.thumbnails } page="about" />
                {
                    page.outro ? (
                        <div className="outro">
                            <p dangerouslySetInnerHTML={{ __html: page.outro }}></p>
                        </div>
                    ) : ''
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { about } = state.page
    return {
        about
    }
}
const connectedAbout = connect(mapStateToProps)(About)
export { connectedAbout as About }
